import { render, staticRenderFns } from "./ChatBoardSheet.vue?vue&type=template&id=701a0821&scoped=true&"
import script from "./ChatBoardSheet.vue?vue&type=script&lang=js&"
export * from "./ChatBoardSheet.vue?vue&type=script&lang=js&"
import style0 from "./ChatBoardSheet.vue?vue&type=style&index=0&id=701a0821&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701a0821",
  null
  
)

export default component.exports